import { Button, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useContext, useEffect, useState } from "react"
import { UserContext } from "../../Providers/UserContext/UserContex"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"
import OneInput from '../OneInput/OneInput'
import { showNotify } from "../../Utils/Utils"
import OneSelect from "../OneSelect/OneSelect"
import OneTextArea from "../OneTextArea/OneTextArea"

let motivoPausa = []
export const FormJornada = ({ setOpen }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { user, check } = useContext(UserContext)

    const [loading, setLoading] = useState(true)
    const [emoji, setEmoji] = useState({
        value: (check.humor ? check.humor : 0)
    })
    const [initialData] = useState({
        id_obs: (check.motivoPausa ? check.motivoPausa : 0)
    })
    const [formData, setFormData] = useState({
        ramal: check.ramal,
        descreva: false,
        id_obs: check.motivoPausa
    })

    useEffect(() => {
        addRoute('buscarListagens#pausa', listPausa)
        sendWs('buscarListagens#pausa', { listagens: { pausa: ['id', 'obs'] } })
    }, [])

    const listPausa = (msg) => {
        motivoPausa = []
        if (msg && msg.data && msg.data.listagens && msg.data.listagens.pausa) {
            msg.data.listagens.pausa.forEach(pausa => {
                motivoPausa.push({ value: pausa.id, nome: pausa.obs })
            })
        }
    }

    const handleSubmit = (data) => {
        data.preventDefault()
        if (formData.ramal && emoji.value > 0 && (check.estado_jornada == 4 || !check.estado_jornada)) {
            sendWs('checkin_out', { operacao: "01", senha: user.senha_checkin, ramal: formData.ramal, sistema: 2, humor: emoji.value, descreva: (!formData.descreva ? '' : formData.descreva), id_usuario: user.id })
            setOpen(false)
        } else if (check.ramal && user.senha_checkin && (check.estado_jornada == 1 || check.estado_jornada == 3)) {
            sendWs('checkin_out', { operacao: "01", senha: user.senha_checkin, ramal: formData.ramal, sistema: 2, id_usuario: user.id })
            setOpen(false)
        } else {
            showNotify('warning', 'Você precisa colocar o humor!')
        }
    }

    useEffect(() => {
        if (user && user.id != null) {
            sendWs('GetDadosCheckin', { id: user.id })
        }
        if (formData) {
            setLoading(false)
        }
    }, [user])

    const handlePause = () => {
        sendWs('pausa_retorno', { operacao: "02", senha: user.senha_checkin, ramal: formData.ramal, sistema: 2, id_obs: formData.id_obs, id_usuario: user.id })
        setOpen(false)
    }

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleChangeHumor = (e, newValue) => {
        setEmoji({ ...emoji, value: newValue })
    }

    const humores = [
        { id: 1, value: 1, emoji: '😢' },
        { id: 2, value: 2, emoji: '🙁' },
        { id: 3, value: 3, emoji: '😐' },
        { id: 4, value: 4, emoji: '🙂' },
        { id: 5, value: 5, emoji: '😀' }

    ]

    return (
        <Grid container item xs={12}>
            {!loading &&
            <form
                id="jornada-form"
                onSubmit={handleSubmit}
            >
                { ((!check.estado_jornada) || (check.estado_jornada == 4)) &&

                    (
                        <>
                            <Grid container xs={12}>
                                <Grid container xs={12} sx={{ alignItems: 'center', width: '100%', gap: 0.5, padding: '5px 0 5px 0', justifyContent: { xs: 'center', sm: 'left' } }}>
                                    <Grid xs={3} sm={1.7} sx={{ width: '20%', textAlign: { xs: 'center', sm: 'left' } }}>
                                        <Typography fontWeight='400' fontSize='15px'>Ramal:</Typography>
                                    </Grid>
                                    <Grid xs={9} sm={10.3} sx={{ maxWidth: { xs: '40%', sm: '20%' }, textAlign: 'center' }}>
                                        <OneInput onChange={handleChange} value={formData.ramal ? formData.ramal : ''} name={"ramal"} maxLength="8"/>
                                    </Grid>
                                </Grid>
                                <Grid container xs={12} sx={{ alignItems: 'center', width: '100%', padding: '0 0 5px 0' }}>
                                    <Grid xs={12} sm={1.5} sx={{ paddingTop: { xs: '5px', sm: '0' }, textAlign: { xs: 'center', sm: 'left' } }}>
                                        <Typography fontWeight='400' fontSize='15px'>Humor:</Typography>
                                    </Grid>
                                    <Grid xs={12} sm={10.5} sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                                        <ToggleButtonGroup
                                            value={emoji.value}
                                            onChange={handleChangeHumor}
                                            exclusive>
                                            {humores.map((humor) => {
                                                return (
                                                    <ToggleButton
                                                        disableRipple
                                                        value={humor.value}
                                                        key={humor.id}
                                                        name={"humor"}
                                                        sx={{
                                                            color: 'rgba(0, 0, 0, 0.2)',
                                                            fontSize: { xs: '20px', sm: '30px' },
                                                            backgroundColor: 'transparent',
                                                            border: 'none',
                                                            '&.Mui-selected': { backgroundColor: 'transparent' },
                                                            '&:hover': { backgroundColor: 'transparent', color: 'unset' },
                                                            '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: 'transparent' }
                                                        }}
                                                    >
                                                        {humor.emoji}
                                                    </ToggleButton>
                                                )
                                            })}
                                        </ToggleButtonGroup>
                                    </Grid>
                                </Grid>
                                <Grid container xs={12} sx={{ width: '100%', alignItems: 'center', justifyContent: { xs: 'center', sm: 'left' } }}>
                                    <Grid xs={12} sm={1.6} sx={{ textAlign: { xs: 'center', sm: 'left' }, padding: { xs: '2px 0 3px 0', sm: '0' } }}>
                                        <Typography fontWeight='400' fontSize='15px'>Descreva:</Typography>
                                    </Grid>
                                    <Grid xs={12} sm={10.4} sx={{ paddingLeft: '10px', height: '100px' }}>
                                        <OneTextArea
                                            placeholder="Descreva o que está sentindo.."
                                            name={"descreva"}
                                            maxLength={150}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>

                    )}
                {(check.estado_jornada == 1 || check.estado_jornada == 2 || check.estado_jornada == 3) &&
                                    (
                                        <Grid xs={12} container item sx={{ width: '550px', minHeight: '100px' }}>
                                            <Grid xs={12} container item gap={1}>
                                                <Grid xs={12} sm={1.8} md={1.4} sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                                                    <Typography fontWeight='400' fontSize='15px'>Ramal:</Typography>
                                                </Grid>
                                                <Grid xs={12} sm={5} md={4}>
                                                    <OneInput disabled={check.estado_jornada == 1 || check.estado_jornada == 3} value={formData.ramal} name={"ramal"} maxLength="4"/>
                                                </Grid>
                                            </Grid>
                                            <Grid xs={12} container item gap={1}>
                                                <Grid xs={12} sm={2} md={1.5}>
                                                    <Typography fontWeight='400' fontSize='15px'>Motivo:</Typography>
                                                </Grid>
                                                <Grid xs sm md>
                                                    {motivoPausa.length > 0 &&
                                                            <OneSelect
                                                                onChange={handleChange}
                                                                options={motivoPausa}
                                                                disabled={check.estado_jornada == 2}
                                                                name={"id_obs"}
                                                                label={"nome"}
                                                                valor={"value"}
                                                                defaultValue={initialData?.id_obs}
                                                                centralizarOpcoes={false}
                                                            />
                                                    }
                                                </Grid>
                                                <Grid>
                                                    <Button color={check.estado_jornada == 2 ? "error" : "primary"} variant="contained" onClick={handlePause}>{check.estado_jornada == 2 ? 'Retorno' : 'Pausa'}</Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                }
            </form>
            }
        </Grid>
    )
}

export const JornadaButton = () => {
    const { check } = useContext(UserContext)
    return (
        <Grid sx={{ justifyContent: 'space-between' }}>
            <Button color="one_primary" disabled={check.estado_jornada == 2} variant="contained" form="jornada-form" type="submit">{check.estado_jornada && check.estado_jornada !== 4 ? 'CHECKOUT' : 'CHECKIN'}</Button>
        </Grid>
    )
}
